import { render, staticRenderFns } from "./InventorySelectionByProduct.vue?vue&type=template&id=510caca2"
import script from "./InventorySelectionByProduct.vue?vue&type=script&lang=js"
export * from "./InventorySelectionByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports